import { render, staticRenderFns } from "./DialogVerLeis.vue?vue&type=template&id=4c66ae08&scoped=true&"
import script from "./DialogVerLeis.vue?vue&type=script&lang=js&"
export * from "./DialogVerLeis.vue?vue&type=script&lang=js&"
import style0 from "./DialogVerLeis.vue?vue&type=style&index=0&id=4c66ae08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66ae08",
  null
  
)

export default component.exports